<template>
    <b-button class="w-100 mb-1" variant="outline-secondary" @click="resetCheckTime">
        <i class="fa-solid fa-arrows-rotate"></i>
        {{ $t('action-items.reset-check-time') }}
    </b-button>
</template>

<script>
export default {
    name: "ResetCheckTime",
    props: [
        'uuids',
        'servicestatus'
    ],
    methods: {
        resetCheckTime(){
            let externalCommands = []
            externalCommands.push({
                serviceUuid: this.uuids.serviceuuid,
                hostUuid: this.uuids.hostuuid,
                satelliteId: this.uuids.satelliteId,
                command: 'rescheduleService'
            });
            this.$emit('command', externalCommands, 'submit');
        },
    }
}
</script>

<style scoped>

</style>
